// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"b8377642","280":"cc20e9c0"}[chunkId] + ".chunk.css";
};